export const locale = {
    lang: 'en',
    data: {
      'FILEMANAGER': {
        'TITULO': 'File manager',
        'SUBTI': 'Upload your company relevant files',
        'GPTW': {
          'TITULO': 'Click on a company name to show the uploaded files list',
          'NUMFILES': 'Number of uploaded files: '
        },
        'CT_NAME':'Collaborators who had severe traumatic event',
        'LABEL01':' Work Centers',
        'CARGA': {
          'TITULO': 'Click here to upload a file or drag and drop it here',
          'CARGANDOTIT': 'Uploading',
          'CARGANTOTXT': 'The file is being sent to the database. Please wait a while.'
        },
        'MENU': {
          'BOTON': 'New',
          'ARCHIVO': 'File',
          'CARPETA': 'Folder',
          'EXCELTI': 'Download Excel TI'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'Name',
            'EXTEN': 'Extension',
            'FECHA': 'Upload date',
            'ACCIONES': 'Actions',
            'TAMANIO': 'Size'
          },
           // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Collaborator name: ',
            'ARCH':'File name',
            'DATE': 'Update date',
            'EXTEN': 'Work center name: ',
            'ACT': 'Actions',
            'BT':'Home'
          },
          'TOOLTIP': {
            'DESCARGA': 'Download this file',
            'DELETE': 'Delete this file',
            'OPENFOLDER': 'Click here to open this folder',
            'VACIO': 'This folder is empty'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'The file was stored successfully',
          'CARGAREP': 'The file was not stored. A file with the same name already exists',
          'DELETERLY': 'Do you confirm to delete this file?',
          'DELETEOK': 'The file was deleted correctly',
          'CREATEFOLDER': 'Enter the name for the new folder',
          'FOLDEROK': 'The folder was created successfully.',
          'archivo_save_4': 'The folder could not be created. A folder with the same name already exists',
          'DELETEFOLDERRLY': 'Do you confirm to delete this folder?\n\nWarning: This folder\'s content will be deleted as well',
          'DELETEFOLDEROK': 'The folder along with its content was deleted successfully',
          'INVALID_CHARS': 'The folder name can only contain characters from letter A to Z and numbers',
          'BOTONES': {
            'SI': 'Yes',
            'NO': 'No',
            'ACEPTAR': 'Accept',
            'CREAR': 'Create',
            'CANCELAR': 'Cancel'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'TI Information',
          'Información CA': 'CA Information',
          'Información General': 'General information',
          'Comunicación NOM035': 'NOM035 Communication',
          'Listado de colaboradores NOM-035': 'NOM-035 Collaboratos List',
          'PDF de resultados NOM-035':'NOM-035 Results PDF',
          'Plantilla listado colaboradores': 'Collaborators list template',
          'Campaña de Comunicación 2020': 'Communication campaign',
          // 'Culture Audit': 'Culture Audit',
          'Guía de certificación': 'Certification guide',
          'Listado de colaboradores': 'Collaborators list',
          'Plantillas': 'Templates',
          'Templates con TI': 'Templates with IT',
          'Templates Página' : 'Page templates',
          'Certificar' : 'Certify',
          'Focus Area' : 'Focus Area',
          'Medir' : 'Measurement',
          'Pulsecheck' : 'Pulse Check',
          'Row Data': 'Row Data',
          'Reports': 'Reports',
          'Campaña de Comunicación 2021 CAYC': 'Communication Campaign 2021 CAYC',

          'Campana de Comunicacion': 'Communication campaign',
          'Culture Audit': 'Culture Audit™',
          'Great Book': 'Great Book',
          'Cuestionarios': 'Questionnaires',
          'Pulse Check': 'Press Check',
          'Base de datos': 'Database',
          'Practicas For All': 'Internships For All',
          'Reporte de Resultados': 'Results report',
          'Validacion': 'Validation',
          'Requerimientos Tecnicos': 'Technical Requirements',
          'Mock ups Encuesta': 'Survey Mock ups'
        }
      }
    }
};
